import React from "react";
import { NavLink } from "react-router-dom";
import { useAuthProvider } from "../customHooks/authContext";
import { Navbar, Nav, Container, Button, Dropdown } from "react-bootstrap";

function NavigationBar() {
  const { isAuthenticated, role, logout } = useAuthProvider();

  if (!isAuthenticated) return null;

  return (
    <Navbar expand="lg" className="app-topbar" sticky="top">
      <Container fluid="xl">
        <Navbar.Brand>Gestion de Inscripciones</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Abrir menu" />
        <Navbar.Collapse id="basic-navbar-nav" className="app-navbar-collapse">
          <Nav className="me-auto app-navbar-links">
            {role.includes("Escuela") && (
              <>
                <Nav.Link as={NavLink} to="/members">
                  Miembros
                </Nav.Link>
                <Nav.Link as={NavLink} to="/registration">
                  Inscripciones
                </Nav.Link>
                <Nav.Link as={NavLink} to="/certificates">
                  Certificados
                </Nav.Link>
              </>
            )}

            {role.includes("Administrador") && (
              <Dropdown>
                <Dropdown.Toggle as={Nav.Link}>
                  Configuracion
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={NavLink} to="/events">Eventos</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/settings/modalities">Modalidades</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/settings/forms">Formas</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/users">Usuarios</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/schools">Escuelas</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

            {role.includes("Operador") && (
              <Dropdown>
                <Dropdown.Toggle as={Nav.Link}>
                  Configuracion
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={NavLink} to="/events">Eventos</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/settings/modalities">Modalidades</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/settings/forms">Formas</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/teachers">Maestros preparadores</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/users">Usuarios</Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/schools">Escuelas</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Nav>

          <Button
            variant="outline-secondary"
            className="app-logout-button"
            onClick={logout}
            as={NavLink}
            to="/login"
          >
            Salir
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
